<template>
  <div
    class="modal fade"
    id="WhatsappManagerPopUp"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-subscription">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12"></div>
            <div class="col-sm-12">
              Comunícate con nosotros a través de WhatsApp para absolver
              cualquier duda que puedas tener:
            </div>
          </div>
          <table class="table table-striped mt-4">
            <thead>
              <tr>
                <th scope="col">Tienda</th>
                <th scope="col">Nombre</th>
                <th scope="col">Enlace</th>
                <th scope="col">Teléfono</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td align=" left">Canal Virtual</td>
                <td align=" left">Sr. Willy S.</td>
                <td>
                  <a
                    class="whatsapp-link"
                    href="https://wa.link/i8zi4v"
                    target="_blank"
                  >
                    <i class="fa fa-whatsapp"></i>
                  </a>
                </td>
                <td>
                  <a href="https://wa.link/i8zi4v">922 442 902</a>
                </td>
              </tr>
              <tr>
                <td align="left">Canal Virtual</td>
                <td align="left">Srta. Betsy P.</td>
                <td>
                  <a
                    class="whatsapp-link"
                    href="https://wa.link/sufg1u"
                    target="_blank"
                  >
                    <i class="fa fa-whatsapp"></i>
                  </a>
                </td>
                <td>
                  <a href="https://wa.link/sufg1u">937 050 266</a>
                </td>
              </tr>
              <tr>
                <td align="left">Canal Virtual</td>
                <td align="left">Sr. Luis C.</td>
                <td>
                  <a
                    class="whatsapp-link"
                    href="https://wa.link/2exm18"
                    target="_blank"
                  >
                    <i class="fa fa-whatsapp"></i>
                  </a>
                </td>
                <td>
                  <a href="https://wa.link/2exm18">947 600 957</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhatsappManagerPopUp',
};
</script>

<style>
#WhatsappManagerPopUp {
  font-size: 14px;
  .table a.whatsapp-link {
    color: #25d366;
    font-size: 25px;
    margin-right: 05px;
    text-align: center;
  }
}
</style>
